import * as THREE from "three";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";

export const FAT_LINE_WIDTH = 2;

/**
 * A screen-space-width line material (WebGL clamps a plain line to 1px, so any
 * width > 1 needs the projected-quad LineMaterial). `resolution` must track the
 * canvas size for the pixel width to be correct — callers own a `THREE.Vector2`
 * they keep in sync via `applyFatLineResolution` on resize. `depthTest:false`
 * keeps the line drawn on top, matching the gizmo / selection-frame overlay look.
 */
export function fatLineMaterial(color: THREE.ColorRepresentation): LineMaterial {
  return new LineMaterial({
    color: new THREE.Color(color).getHex(),
    linewidth: FAT_LINE_WIDTH,
    worldUnits: false,
    depthTest: false,
    transparent: true,
  });
}

/**
 * Copies a resolution into every LineMaterial under `root`. Gizmo / rail handles
 * rebuild their fat lines on each attach, so this re-applies the current canvas
 * size after a rebuild and on window resize.
 */
export function applyFatLineResolution(root: THREE.Object3D, width: number, height: number): void {
  root.traverse((obj: THREE.Object3D): void => {
    const material = (obj as Partial<{ material: unknown }>).material;
    if (material instanceof LineMaterial) {
      material.resolution.set(width, height);
    }
  });
}
